import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

export default function ContactUsScreen() {
  return (
    <Container className="my-5">
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <div className="text-center">
        <h1>Get In Touch</h1>
        <p className="lead text-muted">
          We'd love to hear from you! Choose your preferred way to connect with
          us below.
        </p>
      </div>

      <Row className="justify-content-md-center mt-5">
        {/* Email Contact Card */}
        <Col md={5} className="mb-4">
          <Card className="h-100 text-center">
            <Card.Body className="d-flex flex-column">
              <i
                className="fas fa-envelope fa-3x mb-3"
                style={{ color: '#c71585' }}
              ></i>
              <Card.Title>Contact via Email</Card.Title>
              <Card.Text>
                For any inquiries, support, or feedback, please send us an
                email. We aim to respond within 24 hours.
              </Card.Text>
              <div className="mt-auto">
                <Button
                  variant="primary"
                  href="mailto:qdancewear@gmail.com"
                  className="w-100"
                >
                  Email Us
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Instagram Contact Card */}
        <Col md={5} className="mb-4">
          <Card className="h-100 text-center">
            <Card.Body className="d-flex flex-column">
              <i
                className="fab fa-instagram fa-3x mb-3"
                style={{ color: '#c71585' }}
              ></i>
              <Card.Title>Message on Instagram</Card.Title>
              <Card.Text>
                Follow us and send a direct message for quick questions and to
                see our latest updates and designs.
              </Card.Text>
              <div className="mt-auto">
                <Button
                  variant="outline-primary"
                  href="https://www.instagram.com/q.dancewear/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-100"
                >
                  Go to Instagram
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}